'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoDeviceCamera = function GoDeviceCamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 15c-2.8 0-5 2.2-5 5s2.2 5 5 5c0.2 0 0.4 0 0.7 0-1.9-0.3-3.2-1.9-3.2-3.8 0-2 1.7-3.7 3.7-3.7 1.9 0 3.5 1.4 3.8 3.2 0-0.3 0-0.5 0-0.7 0-2.8-2.2-5-5-5z m15-5h-5l-5-5h-10l-5 5h-5c-1.4 0-2.5 1.1-2.5 2.5v17.5c0 1.4 1.1 2.5 2.5 2.5h30c1.4 0 2.5-1.1 2.5-2.5v-17.5c0-1.4-1.1-2.5-2.5-2.5z m-18.7-2.5h7.5l2.5 2.5h-12.5l2.5-2.5z m-10 22.5c-0.7 0-1.3-0.6-1.3-1.3v-11.2h2.5v-2.5h-2.5v-1.2c0-0.7 0.6-1.3 1.3-1.3h7.1c-0.2 0.1-0.3 0.3-0.5 0.4-3.9 3.9-3.9 10.3 0 14.2l3 2.9h-9.6z m13.7-2.5c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z m12.5-8.7l-5.9-6.3h5.9v6.3z' })
        )
    );
};

exports.default = GoDeviceCamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/device-camera.js
// module id = 2144
// module chunks = 168707334958949